import { useEffect } from "react";

export const useFeeAlertInjectionScript = ({customerId, catalogOsr}) => {
    useEffect(() => {
        if(!customerId || !catalogOsr) return;
        // Return if Fee Alert Script is already injected.
        if(document.querySelector('#fee-alert-message-script')) return;

        const feeAlertScriptElement = document.createElement('script');
        feeAlertScriptElement.src = '/apps/jcom/s4/src/component/jos-fee-alert/js/jos-fee-alert-extended.js';
        feeAlertScriptElement.setAttribute("data-ot-ignore", "data-ot-ignore");
        feeAlertScriptElement.setAttribute("id", "fee-alert-message-script");

        feeAlertScriptElement.onload = () => {
            window?.jostensServiceFeeAlert?.showServiceFeeAlert({
                customerId: customerId,
                catalogOsr: catalogOsr,
            })
        };

        document.head.appendChild(feeAlertScriptElement);
    }, [customerId, catalogOsr]);
}